import { useState } from "react";
import { Box, Collapse, Flex, Text } from "@chakra-ui/react";
import styles from "./ProyekPage.module.css";
import Footer from "../components/Footer";

const FILTER_CATEGORIES = [
  "SEMUA",
  "GUDANG & KAWASAN INDUSTRI",
  "KOMERSIL",
  "HUNIAN PRIBADI",
  "TAMBAK & BUDIDAYA",
];

const projects = [
  {
    name: "Graha Padma Semarang",
    image: "/assets/project/Graha Padma Semarang.png",
    category: "KOMERSIL",
    description:
      "Pembangunan mall open-air di hunian elite menggunakan Kuriabar 8mm sebagai tulangan jalan dan plaza. Material ini dipilih karena kuat, rapi, dan mudah dipasang, menjamin infrastruktur luar ruangan awet seindah desainnya.",
  },
  {
    name: "Grand Wisata Bekasi",
    image: "/assets/project/Grand Wisata Bekasi.png",
    category: "KOMERSIL",
    description:
      "Pembangunan jalan Grand Wisata Bekasi menggunakan Kuriabar sebagai tulangan beton pengganti wiremesh. Hasilnya kuat, rapi, dan berkualitas tinggi, sehingga developer menjadikannya andalan untuk proyek jangka panjang.",
  },
  {
    name: "Gudang PT Digi",
    image: "/assets/project/Gudang-PTDigi.png",
    category: "GUDANG & KAWASAN INDUSTRI",
    description:
      "Pada proyek gudang PT Digi dengan luas area lebih dari 1 hektar, Kuriabar diaplikasikan dengan sistem bentang panjang tanpa sambungan, pengelasan, atau pemotongan di lapangan. Konfigurasi ini memungkinkan area gudang dibuat los dan terbuka secara optimal.",
  },
  {
    name: "Gudang Sido Muncul",
    image: "/assets/project/Gudang Sido Muncul.png",
    category: "GUDANG & KAWASAN INDUSTRI",
    description:
      "Gudang Sidomuncul memakai Kuriabar 8mm dengan panjang hingga 100m untuk bentang bangunan 108m. Minim sambungan membuat rakitan lebih cepat, rapi, dan ringan, sehingga proses pengecoran jauh lebih efisien dan hemat waktu.",
  },
  {
    name: "Jatengland Industrial Park Sayung (JIPS)",
    image: "/assets/project/JIPS.png",
    category: "GUDANG & KAWASAN INDUSTRI",
    description:
      "Kuriabar menjadi solusi utama infrastruktur di JIPS Sayung untuk jalan hingga gedung manufaktur. Kualitas presisi dan daya tahan beban tingginya terpercaya menopang fondasi kemajuan kawasan industri secara berkelanjutan.",
  },
  {
    name: "Jatiluhur Industrial Smart City",
    image: "/assets/project/Jatiluhur Industrial Smart City.png",
    category: "GUDANG & KAWASAN INDUSTRI",
    description:
      "Kawasan Industri Jatiluhur milik Wings Group menggunakan Kuriabar 5mm & 6mm untuk jalan Smart City. Berlokasi di Purwakarta, material ini mencerminkan konsep cerdas melalui efisiensi dan kekuatan pada proyek skala besar.",
  },
  {
    name: "Kawasan Industri Candi Semarang",
    image: "/assets/project/Kawasan Industri Candi Semarang.png",
    category: "GUDANG & KAWASAN INDUSTRI",
    description:
      "Sebagai kawasan industri tertua di Jawa Tengah, KIC memakai Kuriabar untuk perbaikan jalan. Material ini meningkatkan kekuatan dan durabilitas struktur, serta memberikan solusi tulangan ringan, efisien, dan tahan korosi.",
  },
  {
    name: "Kawasan Industri Losarang",
    image: "/assets/project/Kawasan Industri Losarang.png",
    category: "GUDANG & KAWASAN INDUSTRI",
    description:
      "Di Kawasan Industri Losarang, PT Sinar Mekar Jaya memakai Kuriabar 10mm sebagai tulangan jalan. Material anti korosi ini kuat untuk beban berat, ringan, dan mempercepat pengerjaan tanpa mengurangi performa struktur beton.",
  },
  {
    name: "KOKO Smart Terumbu Karang",
    image: "/assets/project/KOKO Smart Terumbu Karang.png",
    category: "TAMBAK & BUDIDAYA",
    description:
      "Proyek restorasi terumbu karang menggunakan GFRP Bar 16mm sebagai tulangan vertikal dan cincin rock bommie. Material ini tahan korosi air laut dan arus ekstrem, menjamin kekuatan struktur bawah air dalam jangka panjang.",
  },
  {
    name: "Kolam Renang Bali",
    image: "/assets/project/Kolam Renang Bali.png",
    category: "KOMERSIL",
    description:
      "Kuriabar 8mm digunakan pada dinding dan dasar kolam renang agar stabil di area lembap. Pada proyek irigasi, material ini berfungsi sebagai tulangan mirip wiremesh yang ringan, bebas korosi, dan efisien saat dipasang.",
  },
  {
    name: "Komplek Pergudangan Platinum Pekanbaru",
    image: "/assets/project/Komplek Pergudangan Platinum Pekanbaru.png",
    category: "GUDANG & KAWASAN INDUSTRI",
    description:
      "Gudang Platinum Pekanbaru menggunakan Kuriabar untuk lantai beton. Material ini dipilih karena kuat menahan beban berat forklift dan logistik harian, memastikan lantai gudang awet, aman, dan tahan lama untuk bisnis di Riau.",
  },
  {
    name: "Malibu Beach Front",
    image: "/assets/project/Malibu Beach Front.png",
    category: "KOMERSIL",
    description:
      "Malibu Beach Front POJ City menggunakan Kuriabar 8mm untuk plat lantai hingga kolam ikonik. Material ini dipilih karena tahan korosi air laut, ringan, dan mudah dipasang, menjamin struktur kuat serta estetika di pesisir.",
  },
  {
    name: "Mandiri Citra Abadi",
    image: "/assets/project/Mandiri Citra Abadi.png",
    category: "GUDANG & KAWASAN INDUSTRI",
    description:
      "Gudang besi ini menggunakan Kuriabar 8mm untuk plat lantai agar kuat menahan beban logam berat. Meski kecil, daya tariknya setara baja konvensional, tahan korosi, dan minim retak, memberikan efisiensi tinggi saat dipasang.",
  },
  {
    name: "PT EPA Cikarang",
    image: "/assets/project/PT EPA Cikarang.png",
    category: "GUDANG & KAWASAN INDUSTRI",
    description:
      "Kontraktor di Cikarang menggunakan Kuriabar untuk perbaikan jalan logistik. Material ini memberikan kekuatan ekstra, minim retak, dan tahan cuaca ekstrem guna menopang beban berat kendaraan industri agar tetap awet dan efisien.",
  },
  {
    name: "PT EPA Cirebon",
    image: "/assets/project/PT EPA Cirebon.png",
    category: "GUDANG & KAWASAN INDUSTRI",
    description:
      "Kontraktor di Cikarang menggunakan Kuriabar untuk perbaikan jalan logistik. Material ini memberikan kekuatan ekstra, minim retak, dan tahan cuaca guna menopang beban berat kendaraan industri agar tetap awet dan efisien.",
  },
  {
    name: "REZ Hotel",
    image: "/assets/project/REZ Hotel.png",
    category: "KOMERSIL",
    description:
      "Proyek parkir 3 lantai Rez Hotel Semarang memakai Kuriabar untuk lantai dasar hingga dak atas. Menggunakan sistem bondek dua lapis, Kuriabar yang ringan mempermudah logistik dan mempercepat pengerjaan beban struktur tinggi.",
  },
  {
    name: "Rumah Hunian, POJ City",
    image: "/assets/project/Rumah-POJ.png",
    category: "HUNIAN PRIBADI",
  },
  {
    name: "Samada Bali",
    image: "/assets/project/Samada Bali.png",
    category: "KOMERSIL",
  },
  {
    name: "Solo Sport Center",
    image: "/assets/project/Solo Sport Center.png",
    category: "KOMERSIL",
    description:
      "Sport center di Solo menggunakan mesh Kuriabar M6 untuk infrastruktur dan plat lantai. Material kuat dan presisi ini menjamin ketahanan area indoor-outdoor terhadap beban berat dan cuaca, memberikan kenyamanan jangka panjang.",
  },
  {
    name: "Tambak Udang Cilacap",
    image: "/assets/project/Tambak Udang Cilacap.png",
    category: "TAMBAK & BUDIDAYA",
    description:
      "Tambak udang di Cilacap memakai Kuriabar untuk dinding dan tiang kolam karena anti korosi air laut. Anyaman Kuriabar yang dicor dan dilapisi terpal menjamin struktur kokoh, hemat biaya rawat, serta mendukung bisnis berkelanjutan.",
  },
];

const ProjectCard = ({ name, image, description, isExpanded, onToggle }) => (
  <div
    className={styles.projectCard}
    onClick={description ? onToggle : undefined}
  >
    <img src={image} alt={name} className={styles.projectCardImage} />
    <div className={styles.projectCardOverlay}>
      <Text className={styles.projectCardName}>{name}</Text>
      {description && (
        <Collapse in={isExpanded} animateOpacity>
          <Text className={styles.projectCardDescriptionText}>
            {description}
          </Text>
        </Collapse>
      )}
    </div>
  </div>
);

const ProyekPage = () => {
  const [activeFilter, setActiveFilter] = useState("SEMUA");
  const [expandedCard, setExpandedCard] = useState(null);
  const filteredProjects =
    activeFilter === "SEMUA"
      ? projects
      : projects.filter((p) => p.category === activeFilter);

  return (
    <Flex className={styles.container}>
      {/* Hero Section */}
      <div className={styles.heroSection}>
        <Text className={styles.heroSubtitle}>
          SATU MATERIAL, SERIBU SOLUSI
        </Text>
        <Text className={styles.heroTitle}>Galeri Proyek Kuria</Text>
        <div className={styles.filterRow}>
          {FILTER_CATEGORIES.map((cat) => (
            <span
              key={cat}
              className={
                cat === activeFilter
                  ? styles.filterPillActive
                  : styles.filterPill
              }
              onClick={() => setActiveFilter(cat)}
            >
              {cat}
            </span>
          ))}
        </div>
      </div>

      {/* Project Grid */}
      <div className={styles.gridSection}>
        <div className={styles.projectGrid}>
          {filteredProjects.map((project) => (
            <ProjectCard
              key={project.name}
              {...project}
              isExpanded={expandedCard === project.name}
              onToggle={() =>
                setExpandedCard(
                  expandedCard === project.name ? null : project.name
                )
              }
            />
          ))}
        </div>
      </div>

      {/* Call Out Banner */}
      <Flex className={styles.callOutBanner}>
        <Flex className={styles.callOutTextContainer}>
          <Text className={styles.callOutText}>
            Revolusi Konstruksi Dengan Kuria
          </Text>
          <CallOutButton />
        </Flex>
      </Flex>

      <Footer />
    </Flex>
  );
};

function CallOutButton() {
  return (
    <Box
      as="button"
      className={styles.callOutButton}
      transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
      _hover={{ bg: "#ebedf0" }}
      _active={{
        bg: "#dddfe2",
        transform: "scale(0.98)",
        borderColor: "#bec3c9",
      }}
      _focus={{
        boxShadow:
          "0 0 1px 2px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .15)",
      }}
    >
      <a href="/contact">KONTAK KURIA</a>
    </Box>
  );
}

export default ProyekPage;
